import apiClient from '../axios.js';

export const audienceRuleService = {
  /**
   * 查詢受眾規則列表
   * @param {Object} params - 查詢參數
   * @param {number} params.page - 頁碼
   * @param {number} params.pageSize - 每頁筆數
   * @param {boolean} params.isActive - 是否啟用（選填）
   * @param {boolean} params.isDynamic - 是否動態更新（選填）
   * @param {string} params.name - 規則名稱（選填）
   * @returns {Promise<Object>} 規則列表
   */
  getAudienceRules: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page);
    if (params.pageSize) queryParams.append('pageSize', params.pageSize);
    if (params.isActive !== undefined) queryParams.append('isActive', params.isActive);
    if (params.isDynamic !== undefined) queryParams.append('isDynamic', params.isDynamic);
    if (params.name) queryParams.append('name', params.name);

    const queryString = queryParams.toString();
    const url = `/audience/rules${queryString ? `?${queryString}` : ''}`;
    const response = await apiClient.get(url);
    return response;
  },

  /**
   * 查詢受眾規則詳情
   * @param {string} ruleId - 規則 ID
   * @returns {Promise<Object>} 規則詳情
   */
  getAudienceRule: async (ruleId) => {
    const response = await apiClient.get(`/audience/rules/${ruleId}`);
    return response;
  },

  /**
   * 建立受眾規則
   * @param {Object} ruleData - 規則資料
   * @returns {Promise<Object>} 建立結果
   */
  createAudienceRule: async (ruleData) => {
    const response = await apiClient.post('/audience/rules', ruleData);
    return response;
  },

  /**
   * 更新受眾規則
   * @param {string} ruleId - 規則 ID
   * @param {Object} ruleData - 規則資料
   * @returns {Promise<Object>} 更新結果
   */
  updateAudienceRule: async (ruleId, ruleData) => {
    const response = await apiClient.put(`/audience/rules/${ruleId}`, ruleData);
    return response;
  },

  /**
   * 刪除受眾規則
   * @param {string} ruleId - 規則 ID
   * @returns {Promise<Object>} 刪除結果
   */
  deleteAudienceRule: async (ruleId) => {
    const response = await apiClient.delete(`/audience/rules/${ruleId}`);
    return response;
  },

  /**
   * 啟用/停用受眾規則
   * @param {string} ruleId - 規則 ID
   * @param {boolean} isActive - 是否啟用
   * @returns {Promise<Object>} 更新結果
   */
  toggleAudienceRule: async (ruleId, isActive) => {
    const response = await apiClient.patch(`/audience/rules/${ruleId}/status`, { isActive });
    return response;
  },

  /**
   * 預覽受眾人數
   * @param {Object} rulesConfig - 規則配置
   * @returns {Promise<Object>} 預覽結果
   */
  previewAudience: async (rulesConfig) => {
    const response = await apiClient.post('/audience/rules/preview', { rulesConfig });
    return response;
  },

  /**
   * 手動更新受眾
   * @param {string} ruleId - 規則 ID
   * @returns {Promise<Object>} 更新結果
   */
  calculateAudience: async (ruleId) => {
    const response = await apiClient.post(`/audience/rules/${ruleId}/calculate`);
    return response;
  }
};
